import React from "react";
import GeneralExpenses from "./GeneralExpenses";

/**
 * Expenses component - Manages expense functionality for legal matters
 * Uses the unified GeneralExpenses component with matter-specific endpoints
 */
const Expenses: React.FC = () => {
  return <GeneralExpenses />;
};

export default Expenses;
